// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G_4gASNBh8ALAjoAJ5dI{align-items:center;gap:6px;display:flex}.FJvuQMRVJo64TEh4GdXo{gap:2px;display:flex}.MU6p6UMlw2cCYiByeWjk{background:var(--background-primary-inverted-disabled);color:var(--content-primary-secondary-inverted);border-radius:4px;padding:.5px 4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `G_4gASNBh8ALAjoAJ5dI`,
	"keys": `FJvuQMRVJo64TEh4GdXo`,
	"key": `MU6p6UMlw2cCYiByeWjk`
};
export default ___CSS_LOADER_EXPORT___;
